<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>商品搜索:</label>
            <lk-input placeholder='支持商品编码、通用名、商品名、助记码' class="item" clearable v-model.trim="query.nameMix"></lk-input>
          </div>
          <div class="queryItem">
            <label >门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList" :muiliple="true"></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button class="mr8" type='primary' @click="$router.push({ name: 'goodsTothirdPartyAdd' })">+添加</lk-button>
          <lk-button class="mr8" type='primary' @click="toBatchAdd">+批量添加</lk-button>
          <lk-button class="mr8" type='primary' @click="openBatchModel(1)">批量启用</lk-button>
          <lk-button class="mr8" type='primary' @click="openBatchModel(2)">批量禁用</lk-button>
          <DownloadButton  @on-click="download"></DownloadButton>
        </div>
        <lk-table 
          border 
          :columns='columns'
          :data='tableData'
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel"
        />
      </div>
    </QueryFrame>
    <lk-modal
      title='批量添加'
      v-model="batchAddModel.isShow"
      :mask-closable="false"
      :closable="false"
      @on-ok="toUpload"
      @on-cancel="batchCancel"
    >
      <div style="display:flex;flex-direction:column;align-items:center;">
        <div class="uploader" @click="$refs.file.click()">
          <input type="file" ref="file" @change="fileReader" v-show="false">
          <p>
            <lk-icon type="ios-cloud-upload-outline" size="16"></lk-icon>点击上传
          </p>
        </div>
        <div style="margin-top:12px;">
          {{`上传的文件是:${this.file.name || ''}`}}
        </div>
        <div>
          <a href="https://linkdoc-erp.oss-cn-beijing.aliyuncs.com/erp-uid-3063/872206281646.xlsx?Expires=3211605981&OSSAccessKeyId=LTAIhQ088Y2NYQem&Signature=z2rDeOU9SIsBwGQr%2BNEaypveTi0%3D">点击下载批量添加模板.xlsx</a>
        </div>
      </div>
    </lk-modal>
    <lk-modal
      title='温馨提示'
      v-model="batchUpdateStatusModel.isShow"
      :mask-closable="false"
      :closable="false"
      @on-ok="toUpdateStatus"
    >
      <p v-if="batchUpdateStatusModel.currentModel === 1">批量启用后，所有门店+商品的信息都会再次推送到第三方平台。请再次确认是否批量启用？</p>
      <p v-if="batchUpdateStatusModel.currentModel === 2">批量禁用后，所有门店+商品的信息都不再推送到第三方平台。请再次确认是否批量禁用？</p>
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import inputSearch from '../../components/InputSearch.vue';
import DownloadButton from '../../components/download/DownloadButton';
import tools from '../../services/tools';
import goods from '../../services/goods';
import utils from '../../libs/utils';

export default {
  name: 'goodsTothirdParty',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    inputSearch,
  },
  computed: {
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item);
      });
      return result;
    }
  },
  data() {
    return {
      thirdPartyList: [
        {
          id: 1,
          name: '药联'
        }
      ],
      batchAddModel: {
        isShow: false,
      },
      batchUpdateStatusModel: {
        isShow: false,
        currentModel: 1, // 1是启用弹窗, 2是禁用弹窗
      },
      query: {
        nameMix: '',
        storeIdList: [],
      },
      tempGoods: [],
      loading: false,
      file: '',
      tableData: [],
      count: 0,
      page: 1,
      columns: [
        { type: 'selection', width: 60 },
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '第三方平台', key: 'type', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: 'SKUID', key: 'skuId', minWidth: 116 },
        { title: 'SKU名称', key: 'skuName', minWidth: 116 },
        { title: '基础商品编码', key: 'serialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: 'SKU包装规格', key: 'specifications', minWidth: 116 },
        { title: 'SKU包装单位', key: 'minPkgUnit', minWidth: 116 },
        { title: '转换系数', key: 'num', minWidth: 116 },
        { title: 'SKU销售价格', key: 'price', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '修改时间', key: 'modifiedTime', minWidth: 116 },
        {
          title: '状态',
          width: 100,
          render: (h, params) => h('div', [
            h('lk-switch', {
              props: {
                size: 'large',
                value: params.row.status === 1,
              },
              on: {
                'on-change': () => {
                  const param = {
                    idList: [params.row.id],
                    status: params.row.status === 1 ? 2 : 1,
                  }
                  tools.toThirdBatchUpdateStatus(param).then(res => {
                    if (res.data.status === 200) {
                      this.$Message.success('操作成功');
                      this.getData();
                    } else {
                      this.$Message.error(res.data.error);
                    }
                  }).catch(err => {
                    utils.handleError(err);
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open',
              }, '启用'),
              h('span', {
                slot: 'close',
              }, '禁用'),
            ])
          ])
        },
        {
          title: '操作',
          width: 100,
          fixed: 'right',
          render: (h, params) => h('lk-button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                this.$router.push({ name: 'goodsTothirdPartyEdit', params: { id: params.row.id } })
              }
            }
          }, '编辑')
        }
      ],
    }
  },
  methods: {
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(row.id)) {
        this.tempGoods.push(row.id);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        if (item === row.id) {
          this.tempGoods.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.id)) {
          this.tempGoods.push(item.id);
        }
      });
    },
    handleSelectAllCancel() {
      this.tempGoods = [];
    },
    toBatchAdd() {
      this.batchAddModel.isShow = true;
    },
    toUpdateStatus() {
      const params = {
        idList: this.tempGoods,
        status: this.batchUpdateStatusModel.currentModel === 1 ? 1 : 2, // 启用传1，禁用传2
      }
      tools.toThirdBatchUpdateStatus(params).then(res => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error)
        } else {
          this.$Message.success('操作成功');
          this.tempGoods = [];
          this.getData();
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    openBatchModel(value) {
      if (!this.tempGoods.length) {
        this.$Message.error('请先选择商品');
        return
      }
      this.batchUpdateStatusModel.currentModel = value;
      this.batchUpdateStatusModel.isShow = true;
    },
    fileReader(e) {
      this.loading = true;
      this.file = e.target.files[0];
      e.target.value = null;
    },
    batchCancel() {
      this.file = '';
    },
    toUpload() {
      var form = new FormData();
      form.append('file', this.file)
      tools.toUploadFile(form).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('上传成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      tools.toThirdGoodsList(this.params).then(res => {
        if (res.data.status === 200) {
          let data = res.data.data;
          this.count = data.count;
          data.list.forEach(item => {
            item.type = this.thirdPartyList[item.type - 1].name;
            item.createTime = utils.formatDateToSecond(item.createTime);
            item.modifiedTime = utils.formatDateToSecond(item.modifiedTime);
          })
          this.tableData = data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    clear() {
      this.query = {
        nameMix: '',
        storeIdList: [],
      }
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      tools.toExportFile(params).then(res => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error)
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
  },
  mounted() {
    this.handleSearch(true);
  }
}
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 12px;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .margin-left {
    margin-left: 12px;
  }
  .margin-bottom {
    margin-bottom: 12px;
  }
  .select {
    width: 200px;
  }
  .uploader {
    height: 28px;
    width: 87px;
    border: 1px dashed #dedede;
    text-align: center;
    position: relative;
    cursor: pointer;
    line-height: 1.2;
    p {
      line-height: 28px;
      font-size: 12px
    }
  }
</style>